import { regions, years } from "@/data/videos";
import type { FilterState } from "@/data/videos";

interface FilterBarProps {
  filter: FilterState;
  onChange: (filter: FilterState) => void;
  typeOptions: string[];
  sort: string;
  onSortChange: (sort: string) => void;
  onReset: () => void;
}

const sortOptions = [
  { value: "default", label: "默认排序" },
  { value: "newest", label: "最新上传" },
  { value: "hot", label: "播放最多" },
];

function SelectField({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}) {
  return (
    <label className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2">
      <span className="whitespace-nowrap text-xs text-foreground-500">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="cursor-pointer bg-transparent text-sm font-medium text-foreground-900 outline-none"
      >
        <option value="全部">全部</option>
        {options
          .filter((o) => o !== "全部")
          .map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
      </select>
      <i className="ri-arrow-down-s-line text-base text-foreground-400"></i>
    </label>
  );
}

export default function FilterBar({
  filter,
  onChange,
  typeOptions,
  sort,
  onSortChange,
  onReset,
}: FilterBarProps) {
  const hasActive =
    filter.year !== "全部" || filter.region !== "全部" || filter.type !== "全部";

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
          <span className="hidden items-center gap-1 text-xs font-semibold text-foreground-500 sm:flex">
            <i className="ri-filter-3-line"></i>
            筛选
          </span>
          <SelectField
            label="年份"
            value={filter.year}
            options={years}
            onChange={(v) => onChange({ ...filter, year: v })}
          />
          <SelectField
            label="地区"
            value={filter.region}
            options={regions}
            onChange={(v) => onChange({ ...filter, region: v })}
          />
          <SelectField
            label="类型"
            value={filter.type}
            options={typeOptions}
            onChange={(v) => onChange({ ...filter, type: v })}
          />
          {hasActive && (
            <button
              type="button"
              onClick={onReset}
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-2 py-2 text-xs font-medium text-accent-600 transition-colors hover:text-accent-700"
            >
              <i className="ri-refresh-line"></i>
              重置筛选
            </button>
          )}
        </div>

        <div className="flex items-center gap-1 self-start rounded-full border border-background-200 bg-background-50 p-1 lg:self-auto">
          {sortOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSortChange(opt.value)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                sort === opt.value
                  ? "bg-primary-500 text-background-50"
                  : "cursor-pointer text-foreground-600 hover:text-primary-600"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}